import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import LegendsBanner from '@cont/Banner/LegendsBanner';
import Course from '@models/Course';
import H2 from '@base/H2/H2';
import H5 from '@base/H5/H5';
import { Spacings, Fonts, breakpoints } from '@styles/index';
import GenericBanner from './GenericBanner';

const Wrapper = styled.div`
  display: ${({ singleBanner }) => (singleBanner ? 'block' : 'flex')};
  width: 1136px;
  margin: auto;
  margin-top: 160px;
  align-items: center;
  @media only screen and (max-width: ${breakpoints.mobile}) {
    width: 100%;
    margin-top: ${Spacings.SPACING_20B};
    flex-direction: column;
  }
`;

const LegendsBannerWrapper = styled.div`
  height: 265px;
  position: relative;
  width: 850px;
  @media only screen and (max-width: ${breakpoints.mobile}) {
    width: 100%;
    padding: 0 ${Spacings.SPACING_4B};
    margin-top: ${Spacings.SPACING_4B};
    height: auto;
  }
`;

const Context = styled.div`
  width: 246px;
  margin-right: ${Spacings.SPACING_10B};
  h5 {
    margin-top: ${Spacings.SPACING_8B};
    font-weight: ${Fonts.REGULAR};
    color: var(--color-text-primary);
    @media only screen and (max-width: ${breakpoints.mobile}) {
      margin-top: ${Spacings.SPACING_1B};
    }
  }
  @media only screen and (max-width: ${breakpoints.mobile}) {
    width: 100%;
    padding: 0 ${Spacings.SPACING_4B};
    margin: 0;
  }
`;

const Title = styled(H2)`
  @media only screen and (max-width: ${breakpoints.mobile}) {
    font-size: 22px;
  }
`;

const PresubscribedLegendsSection = ({ block }) => {
  const handleEnrollClick = () => {};
  const { extraBlockInfo } = block;
  if (!block.data || !block.data.find((courses) => courses)) return null;
  if (block.type === 'generic_banner') {
    return (
      <Wrapper singleBanner>
        <GenericBanner block={block} />
      </Wrapper>
    );
  }
  return (
    <Wrapper>
      <Context>
        <Title color="var(--color-text-primary)">
          {extraBlockInfo?.subTitle
            ? extraBlockInfo.subTitle
            : 'Learn from the Legends'}
        </Title>
        <H5>
          {extraBlockInfo?.subDescription
            ? extraBlockInfo.subDescription
            : 'Watch lessons from the best as they share their stories, shortcuts, failures, and successes.'}
        </H5>
      </Context>
      <LegendsBannerWrapper>
        <LegendsBanner
          course={Course.getEntityData(block.data.find((courses) => courses))}
          enroll={handleEnrollClick}
          bannerType={1}
          isUnsigned
        />
      </LegendsBannerWrapper>
    </Wrapper>
  );
};

export default PresubscribedLegendsSection;

PresubscribedLegendsSection.propTypes = {
  block: PropTypes.objectOf(PropTypes.any)
};

PresubscribedLegendsSection.defaultProps = {
  block: { data: null }
};
